import { Box, Container, Typography, Link, Stack } from "@mui/material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "#228B22",
        color: "#fff",
        py: 4,
        mt: 5,
      }}
    >
      <Container maxWidth="lg">
        
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={3}
          justifyContent="space-between"
        >
          
          <Box>
            <Typography variant="h6" gutterBottom>
              Provincial TB Control Program
            </Typography>
            <Typography variant="body2">
             Hayatabad Phase 5 Peshawar KP.
            </Typography>
          </Box>

          <Box>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            <Stack spacing={1}>
              <Link href="#" color="inherit" underline="hover">Home</Link>
              <Link href="#" color="inherit" underline="hover">Services</Link>
              <Link href="#" color="inherit" underline="hover">About</Link>
              <Link href="#" color="inherit" underline="hover">Contact</Link>
            </Stack>
          </Box>

          {/* Contact */}
          <Box>
            <Typography variant="h6" gutterBottom>
              Contact
            </Typography>
            <Typography variant="body2">Email: info@example.com</Typography>
            <Typography variant="body2">Phone: +92 300 0000000</Typography>
          </Box>

        </Stack>

        <Typography
          variant="body2"
          align="center"
          sx={{ mt: 3, opacity: 0.7 }}
        >
          © {new Date().getFullYear()} PTP KP. All rights reserved.
        </Typography>

      </Container>
    </Box>
  );
}